import React from "react";
import ICON from "components/cmp_icon/cmp_icon";

import './cmp_stat.css';


export default function CMP_STAT({ status, total, breakdown, ready, onSelect, isSelected }) {

  const calculatePercentages = () => {
    if (!breakdown || breakdown.length === 0) return [];
    const count = breakdown.reduce((acc, item) => acc + item.value, 0);
    return breakdown
      .filter(item => item.value > 0)
      .map(item => ({
        ...item,
        percentage: (item.value / count) * 100
      }));
  };

  const percentages = calculatePercentages();
  const loadingBreakdown = [{ label: 'Loading statistics', color: 'var(--color-gray-150)', value: 1, percentage: 100 }];
  const displayBreakdown = ready && percentages.length > 0 ? percentages : loadingBreakdown;

  return (
    <div
      className={`card stat ${isSelected ? 'stat--selected' : ''}`}
      onClick={onSelect}
      style={{ cursor: 'pointer' }}
    >
      <div className='card__header'>
        <div className='text--base'>{status}</div>
      </div>
      <div className='text--lg bold'>{ready && total ? total.toLocaleString() : '-'}</div>
      <div className='stat__breakdown__wrapper'>
        <div className='stat__breakdown'>
          {displayBreakdown.map((segment, index) =>
            <div
              key={index}
              className='stat__segment'
              style={{
                width: `${segment.percentage}%`,
                backgroundColor: segment.color
              }}
              title={ready ? `${segment.label}: ${segment.value}` : 'Loading...'}
            />
          )}
        </div>
        <div className='stat__legend'>
          {displayBreakdown.map((segment, index) =>
            <div key={index} className='stat__legend__item'>
              <div className='stat__legend__dot' style={{ backgroundColor: segment.color }}></div>
              <div className='stat__legend__text text--xs'>{segment.label}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}